import { render, staticRenderFns } from "./side-navigation.vue?vue&type=template&id=1ed89d5a&scoped=true"
import script from "./side-navigation.vue?vue&type=script&lang=js"
export * from "./side-navigation.vue?vue&type=script&lang=js"
import style0 from "./side-navigation.vue?vue&type=style&index=0&id=1ed89d5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed89d5a",
  null
  
)

export default component.exports